<div class="grid gap-8">
  <div
    class="bg-landing-coolGray-50 border border-landing-coolGray-600 rounded-[16px] p-4 pr-[40px] relative cursor-pointer"
    (click)="extended = !extended"
  >
    <div class="text-18 font-bold">{{ title }}</div>
    <app-svg-icon
      [icon]="extended ? 'x' : 'plus'"
      [isV2Icon]="true"
      [width]="24"
      class="text-landing-gray-700 absolute top-[17px] right-4"
    ></app-svg-icon>
  </div>

  <div *ngIf="extended" class="text-16">
    <ng-content></ng-content>
  </div>
</div>
